export const IMPORT_MODAL = "import-modal";
export const CREATE_TASK_MODAL = "create-task-modal";
export const EDIT_TASK_MODAL = "edit-task-modal";
export const IS_COST = "is-cost";
export const CREATE_MY_BOOKING_MODAL = "create-my-booking-modal";
export const EDIT_MY_BOOKING_MODAL = "edit-my-booking-modal";
export const FRINGE_BENEFIT_MODAL = "fringe-benefit-modal";
export const ASSISTANCE_MODAL = "assistance-modal";
export const TAG_MASS_ASSOCIATION_MODAL = "tag-mass-association-modal";